import { REACT_APP_URL_DICTIONARY_LIST_ALL } from '../components/common/Routes/URLs';
import ApiServices from './ApiServices';

let dictionaryRequest = null;
const listeners = new Set();

/**
 * @param {Object} [result] - Backend payload holding one dictionary per language.
 * @returns {{en: Object, es: Object}} Dictionaries keyed by language code.
 * @author armandoricosandoval -ai-
 */
const toDictionaries = (result) => {
  if (!result?.english || !result?.spanish) {
    throw new Error('Dictionary response carries no translations.');
  }
  return { en: result.english, es: result.spanish };
};

/**
 * Fetches the backend dictionaries once and shares the in-flight request with every caller.
 * A public endpoint, so it never waits for a refresh or a new login: the app renders behind DictionaryGate and would hide it.
 * @param {{force?: boolean}} [options] - `force` discards the cached request and fetches again.
 * @returns {Promise<{en: Object, es: Object}>} Dictionaries keyed by language code.
 * @author armandoricosandoval -ai-
 */
export const fetchDictionaries = ({ force = false } = {}) => {
  if (force || !dictionaryRequest) {
    const request = ApiServices.get(REACT_APP_URL_DICTIONARY_LIST_ALL).then((response) => toDictionaries(response?.data?.result));
    dictionaryRequest = request;
    request.then(
      (dictionaries) => listeners.forEach((listener) => listener(dictionaries)),
      () => {
        if (dictionaryRequest === request) {
          dictionaryRequest = null;
        }
      }
    );
  }
  return dictionaryRequest;
};

/**
 * @param {Function} listener - Receives the dictionaries every time a fetch succeeds.
 * @returns {Function} Unsubscribes the listener.
 * @author armandoricosandoval -ai-
 */
export const subscribeToDictionaries = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const resetDictionaryServiceForTests = () => {
  dictionaryRequest = null;
  listeners.clear();
};
